import React, { useState, useEffect, Fragment } from "react";
import LazyLoad from "react-lazyload";
// import Image from "next/image";
import { useRouter } from "next/router";
import { convertToImageKit } from "../../utils/convert-to-imagekit";
import useWindowSize from "../../hooks/useWindowSize";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import eventAPI from "../../axios-setup/event-service";
import { Dialog, Transition } from "@headlessui/react";
import { CheckIcon, XIcon } from "@heroicons/react/outline";
import {
  content,
  returnStep2SubHeading,
  returnStep1SubHeading,
} from "../../utils/content/leadModal";

import * as fbq from "../../lib/fpixel";
import * as gtag from "../../lib/gtag";

const ListItem = ({ text, icon }) => {
  return (
    <li style={{ marginTop: "1.25rem" }} className="flex flex-row text-md">
      <img
        style={{ marginRight: "1.25rem" }}
        src={icon}
        className="object-cover rounded-lg h-10 w-10"
      />
      {text}
    </li>
  );
};

const ResendOTP = ({ resendOTP }) => {
  const [timer, setTimer] = React.useState(30);
  React.useEffect(() => {
    setTimeout(() => {
      if (timer > 0) setTimer(timer - 1);
    }, 1000);
  }, [timer]);
  return (
    <div>
      {timer > 0 ? (
        <span className="text-sm">Resend OTP in {timer} sec</span>
      ) : (
        <span
          onClick={() => {
            resendOTP();
            setTimer(30);
          }}
          className="text-sm cursor-pointer font-bold"
        >
          Resend OTP
        </span>
      )}
    </div>
  );
};

const AutoClose = ({ setShowModal }) => {
  const [timer, setTimer] = React.useState(4);
  React.useEffect(() => {
    setTimeout(() => {
      if (timer === 1) {
        setShowModal(false);
        return;
      }
      if (timer > 1) setTimer(timer - 1);
    }, 1000);
  }, [timer]);
  return (
    <div>
      <span className="text-sm text-gray-500">
        Closing the dialog in {timer} sec
      </span>
    </div>
  );
};

const Modal = ({ setShowModal, showModal, page, productExamId, lang }) => {
  const [examId, setExamId] = useState(`${productExamId}`);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [newPhone, setNewPhone] = useState("");
  const [tnc, setTnc] = useState(true);
  const [notification, setNotification] = useState(true);
  const [exams, setExams] = useState([]);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const [edit, setEdit] = useState(false);
  const [examName, setExamName] = useState("Exam");

  const router = useRouter();
  const size = useWindowSize();
  const myLoader = ({ src, width }) => {
    return src + `?tr=w-${size.width}`;
  };
  const header =
    "https://toppersnotes-web.s3.ap-south-1.amazonaws.com/Gallery/Thumbnails/tn-logo-footer.png";

  const regexExp = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;

  const onSubmit = async () => {
    if (!tnc || name == "") {
      toast.error("Fill in all the fields!");
    } else if (!examId) {
      toast.error("Please select an exam");
    } else if (!regexExp.test(phone)) {
      toast.error("Please enter a valid mobile number!");
    } else {
      const singleExam = exams.find((exam) => exam.id == examId);

      const detail = {
        exam_id: examId,
        exam_name: singleExam.exam_name,
        name: name,
        phone: phone,
        browser_id: localStorage.getItem("FPJS").replace(/"/g, ""),
        page_type: page,
        src_page_url: window ? window.location.href : "",
      };
      try {
        setLoading(true);
        await eventAPI.post("/detail", detail);
        setLoading(false);
        toast.success("OTP sent!");

        if (examId == productExamId) {
          fbq.event("Lead");
          gtag.customConversion("conversion", "/EOwOCNqXgbwYEILumc0D");
        }

        setStep(2);
      } catch (err) {
        setLoading(false);
        console.log(err, "Error");
        toast.error(err.message);
      }
    }
  };
  const resendOTP = async () => {
    if (!regexExp.test(newPhone)) {
      toast.error("Please enter a valid mobile number!");
    } else {
      try {
        setLoading(true);
        await eventAPI.post("/detail/sendotp", {
          phone: newPhone,
          browserId: localStorage.getItem("FPJS").replace(/"/g, ""),
        });
        setLoading(false);
        toast.success("OTP sent!");
        setEdit(false);
      } catch (err) {
        setLoading(false);
        console.log(err, "Error");
        toast.error(err.message);
      }
    }
  };

  const onSubmitOTP = async () => {
    if (otp.length !== 4) {
      toast.error("Please enter 4 digit OTP!");
    } else {
      try {
        setLoading(true);
        const res = await eventAPI.post("/detail/verifyotp", {
          phone: phone,
          newPhone: newPhone,
          otp: otp,
        });
        setLoading(false);
        if (!res.data.success) {
          toast.error("Invalid OTP!");
        } else {
          toast.success("Phone number verified!");
          localStorage.setItem("LEAD_MODAL_SUBMITTED_ON", new Date());
          localStorage.setItem("LEAD_MODAL_EXAM_ID", examId);

          if (examId == productExamId) {
            fbq.event("LeadOTPVerified");
            gtag.customConversion("conversion", "/MlJJCNLZp7wYEILumc0D");
          }

          setStep(3);
        }
      } catch (error) {
        setLoading(false);
        console.log(err, "Error");
        toast.error(err.message);
      }
    }
  };

  useEffect(() => {
    const fetchExams = async () => {
      const URL = "https://api.toppersnotes.com/web/v1/fetch/all/exams";
      const token =
        "eBb6yyXEkN9gCieWXqV9sPp6Aupq5QfvLVacjfjK5L66011OgptfNRQoUkc4";

      const headers = { Authorization: `Bearer ${token}` };

      try {
        const res = await axios.get(URL, { headers });

        setExams(res.data);
        if (page === "product") {
          const productExam = res.data.find((ex) => ex.id == productExamId);
          setExamName(productExam.exam_name);
        } else {
          setExamName("Civil Services");
        }
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchExams();
  }, []);

  const CrossIcon = () => {
    return (
      <button
        style={{ margin: "0.75rem" }}
        className="float-right text-end self-start text-xl"
        onClick={() => {
          if (step == 1) {
            localStorage.setItem("LEAD_MODAL_DISMISSED_ON", new Date());
          }

          setShowModal(false);
        }}
      >
        <span className="">×</span>
      </button>
    );
  };

  return (
    <div>
      <div className="rounded-lg justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[99999999999] outline-none focus:outline-none">
        <div
          style={{
            width: "60rem",
            marginTop: "1.5rem",
            // marginBottom: "1.5rem",
          }}
          // z-[99999999999]
          className={`rounded-lg z-[99999999999] relative  ${
            size && size.width < 700 ? "" : ""
          } `}
        >
          {/*content*/}
          <div
            style={{ height: size && size.width > 700 ? "33.5rem" : "35rem" }}
            className="border-0 rounded-lg shadow-lg relative flex flex-row w-full bg-white outline-none focus:outline-none"
          >
            {size && size.width > 700 && (
              <div
                style={{ padding: "0.75rem" }}
                className="bg-[#110F1F] flex-[0.95_0.95_0px] flex flex-col items-center rounded-lg"
              >
                <div style={{ marginTop: "0.75rem" }} className="">
                  <LazyLoad once>
                    {/* <Image
                      unoptimized={true}
                      loader={myLoader}
                      width={170}
                      height={70}
                      src={convertToImageKit(header)}
                      alt="Navbar"
                      priority={true}
                    /> */}
                    <img
                      width={170}
                      height={70}
                      src={convertToImageKit(header)}
                      alt="Navbar"
                    />
                  </LazyLoad>
                </div>
                <h2
                  style={{ marginTop: "1.25rem" }}
                  className="text-white text-2xl"
                >
                  {/* Do you want better RANK in your exam? */}
                  {content["about"]["heading"][lang]}
                </h2>
                <h3
                  style={{ marginTop: "0.75rem" }}
                  className="text-white text-xs"
                >
                  {/* Start your preparations with ToppersNotes's FREE Study
                  Material */}
                  {content["about"]["subHeading"][lang]}
                </h3>
                <div
                  style={{ marginTop: "1.25rem" }}
                  className="h-0.5 w-10/12 bg-[#ccc]"
                />
                <ul style={{ marginTop: "1.25rem" }} className="text-white">
                  <ListItem
                    icon={
                      "https://cdn3.vectorstock.com/i/1000x1000/35/52/placeholder-rgb-color-icon-vector-32173552.jpg"
                    }
                    // text="Updated Syllabus, Paper Pattern & Full Exam Details"
                    text={content["about"]["feature1"][lang]}
                  />
                  <ListItem
                    icon={
                      "https://cdn3.vectorstock.com/i/1000x1000/35/52/placeholder-rgb-color-icon-vector-32173552.jpg"
                    }
                    // text="Sample Theory of Most Important Topic"
                    text={content["about"]["feature2"][lang]}
                  />
                  <ListItem
                    icon={
                      "https://cdn3.vectorstock.com/i/1000x1000/35/52/placeholder-rgb-color-icon-vector-32173552.jpg"
                    }
                    // text="Model Test Paper with Detailed Solutions"
                    text={content["about"]["feature3"][lang]}
                  />
                  <ListItem
                    icon={
                      "https://cdn3.vectorstock.com/i/1000x1000/35/52/placeholder-rgb-color-icon-vector-32173552.jpg"
                    }
                    // text="Last 5 Years Question Papers & Answers"
                    text={content["about"]["feature4"][lang]}
                  />
                </ul>
              </div>
            )}
            {step === 1 && (
              <div className="flex-[1_1_0px]">
                {/*header*/}
                <div className="flex flex-row space-between w-full">
                  <div
                    style={{ padding: "1.25rem" }}
                    className="flex flex-1 items-start justify-between border-b border-solid border-slate-200 rounded-t flex-col"
                  >
                    <h3 className="text-3xl font-semibold">
                      {/* Register */}
                      {content["step1"]["heading"][lang]}
                    </h3>
                    <h4 style={{ marginTop: "0.75rem" }} className="">
                      {/* Register and Start your Learning */}
                      {/* {content["step1"]["subHeading"][lang]} */}
                      {returnStep1SubHeading(lang, examName)}
                    </h4>
                  </div>
                  <CrossIcon />
                </div>
                {/*body*/}
                <div style={{ padding: "1rem" }} className="relative flex-auto">
                  <div
                    style={{ marginTop: "0.8rem", marginBottom: "0.4rem" }}
                    className="text-slate-500 text-lg leading-relaxed"
                  >
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <select
                          style={{ padding: "0.625rem" }}
                          className="bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          value={examId}
                          onChange={(e) => setExamId(e.target.value)}
                          name="examId"
                          placeholder="Select Exam"
                        >
                          <option value={""}>Select Exam</option>
                          {exams.map((exam, i) => (
                            <option value={exam.id} key={i}>
                              {exam.exam_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          style={{ padding: "0.625rem" }}
                          className="bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full   dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                          type="text"
                          name="name"
                          placeholder="Your Name"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12">
                      <div className="form-group">
                        <input
                          style={{ padding: "0.625rem" }}
                          className="bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          value={phone}
                          onChange={(e) => {
                            setPhone(e.target.value);
                            setNewPhone(e.target.value);
                          }}
                          type="text"
                          name="phone"
                          placeholder="Mobile Number"
                        />
                      </div>
                    </div>

                    <div className="col-lg-12 col-md-12">
                      <div className="flex flex-row space-between">
                        <input
                          checked={tnc}
                          onChange={(e) => setTnc(!tnc)}
                          type="checkbox"
                          name="tnc"
                        />
                        <label
                          style={{
                            marginBottom: "0.5rem",
                            marginLeft: "0.3rem",
                          }}
                          htmlFor="tnc"
                          className="block text-sm font-medium text-black dark:text-black"
                        >
                          <span
                            onClick={() => {
                              router.push("/terms-of-service");
                            }}
                            className="text-sky-800 cursor-pointer"
                          >
                            {content["step1"]["tnc"][lang]}
                          </span>
                        </label>
                      </div>

                      <div className="flex flex-row space-between">
                        <input
                          checked={notification}
                          onChange={(e) => setNotification(!notification)}
                          type="checkbox"
                          name="notification"
                        />
                        <label
                          style={{
                            marginBottom: "0.5rem",
                            marginLeft: "0.3rem",
                          }}
                          htmlFor="notification"
                          className="block text-sm font-medium text-black dark:text-black"
                        >
                          {content["step1"]["notification"][lang]}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {/*footer*/}
                <div
                  style={{ padding: "0.5rem" }}
                  className="flex items-center justify-end  border-t border-solid border-slate-200 rounded-b"
                >
                  <button
                    style={{
                      marginRight: "0.25rem",
                      marginBottom: "0.25rem",
                      paddingTop: "0.75rem",
                      paddingBottom: "0.75rem",
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                    }}
                    className="text-red-500 background-transparent font-bold uppercase text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      localStorage.setItem(
                        "LEAD_MODAL_DISMISSED_ON",
                        new Date()
                      );
                      setShowModal(false);
                    }}
                  >
                    {content["step1"]["close"][lang]}
                  </button>
                  <button
                    style={{
                      marginRight: "0.25rem",
                      marginBottom: "0.25rem",
                      paddingTop: "0.75rem",
                      paddingBottom: "0.75rem",
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                    }}
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150"
                    type="button"
                    onClick={onSubmit}
                  >
                    {loading ? "..." : content["step1"]["submit"][lang]}
                  </button>
                </div>
              </div>
            )}
            {step === 2 && (
              <div className="flex-[1_1_0px]">
                {/*header*/}
                <div className="flex flex-row space-between w-full">
                  <div
                    style={{ padding: "1.25rem" }}
                    className="flex flex-1 items-start justify-between border-b border-solid border-slate-200 rounded-t flex-col"
                  >
                    <h3 className="text-3xl font-semibold">
                      {/* You've made a great decision */}
                      {content["step2"]["heading"][lang]}
                    </h3>
                    <h4 style={{ marginTop: "0.75rem" }} className="">
                      {/* We have sent you an OTP on your registerd mobile no.
                      ending
                      {" ---"}
                      {newPhone.slice(-3)}. Please verify it! */}
                      {/* {content["step2"]["subHeading"][lang]} */}
                      {returnStep2SubHeading(lang, newPhone.slice(-3))}
                    </h4>
                    <span
                      onClick={() => setEdit((a) => !a)}
                      className="text-sm text-sky-800 cursor-pointer"
                    >
                      {content["step2"]["changeMobile"][lang]}
                    </span>
                  </div>
                  <CrossIcon />
                </div>
                {/*body*/}
                <div
                  style={{ padding: "1.5rem" }}
                  className="relative flex-auto"
                >
                  <div
                    style={{ marginTop: "1rem", marginBottom: "1rem" }}
                    className="text-slate-500 text-lg leading-relaxed"
                  >
                    {edit && (
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <input
                            style={{ padding: "0.625rem" }}
                            className="bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={newPhone}
                            onChange={(e) => setNewPhone(e.target.value)}
                            type="text"
                            name="newPhone"
                            placeholder="Mobile Number"
                          />
                        </div>
                        <span
                          style={{ marginTop: "1.25rem", padding: "0.75rem" }}
                          className="text-sm font-bold cursor-pointer text-white bg-[#110f1f] rounded-lg"
                          onClick={resendOTP}
                        >
                          Send OTP
                        </span>
                      </div>
                    )}
                    {!edit && (
                      <div className="col-lg-12 col-md-12">
                        <div className="form-group">
                          <input
                            maxLength={4}
                            style={{ padding: "0.625rem" }}
                            className="bg-gray-50 border border-gray-300 text-gray-400 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  dark:border-gray-600 dark:placeholder-gray-400 dark:text-black dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            type="text"
                            name="otp"
                            placeholder="4 digit OTP"
                          />
                        </div>
                        <ResendOTP resendOTP={resendOTP} />
                      </div>
                    )}
                  </div>
                </div>
                {/*footer*/}
                <div
                  style={{ marginTop: "2.5rem", padding: "1.5rem" }}
                  className="flex items-center justify-end border-t border-solid border-slate-200 rounded-b"
                >
                  <button
                    style={{
                      marginBottom: "0.25rem",
                      marginRight: "0.25rem",
                      paddingTop: "0.5rem",
                      paddingBottom: "0.5rem",
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                    }}
                    className="text-red-500 background-transparent font-bold uppercase text-sm outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    {content["step2"]["close"][lang]}
                  </button>
                  <button
                    style={{
                      marginBottom: "0.25rem",
                      marginRight: "0.25rem",
                      paddingTop: "0.75rem",
                      paddingBottom: "0.75rem",
                      paddingLeft: "1.5rem",
                      paddingRight: "1.5rem",
                    }}
                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm rounded shadow hover:shadow-lg outline-none focus:outline-none ease-linear transition-all duration-150"
                    type="button"
                    onClick={onSubmitOTP}
                  >
                    {loading ? "..." : content["step2"]["submit"][lang]}
                  </button>
                </div>
              </div>
            )}
            {step === 3 && (
              <div className="flex-[1_1_0px]">
                {/*header*/}
                <div className="flex flex-row space-between w-full">
                  <div
                    style={{ padding: "1.25rem" }}
                    className="flex flex-1 items-start justify-between border-b border-solid border-slate-200 rounded-t flex-col"
                  >
                    <h3 className="text-2xl font-semibold">
                      {/* Welcome to ToppersNotes! */}
                      {content["step3"]["heading"][lang]}
                    </h3>
                    <h4 style={{ marginTop: "0.75rem" }} className="">
                      {" "}
                      {/* Registration Completed */}
                      {content["step3"]["subHeading"][lang]}
                    </h4>
                  </div>
                  <CrossIcon />
                </div>
                <div
                  style={{ padding: "1.5rem" }}
                  className="relative flex-auto"
                >
                  <div
                    style={{ marginTop: "1rem", marginBottom: "1rem" }}
                    className="text-slate-500 text-lg leading-relaxed"
                  >
                    <div>
                      <div
                        style={{ margin: "0 auto" }}
                        className="flex items-center justify-center h-12 w-12 rounded-full bg-green-100"
                      >
                        <CheckIcon
                          className="h-6 w-6 text-green-600"
                          aria-hidden="true"
                        />
                      </div>
                      <div
                        style={{ marginTop: "0.75rem" }}
                        className="text-center"
                      >
                        {content["step3"]["body"][lang]}
                        <div style={{ marginTop: "0.5rem" }} className="">
                          <p className="text-sm text-gray-500">{name}</p>
                          <p className="text-md text-gray-800">{newPhone}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{ padding: "1.5rem" }}
                  className="flex items-center justify-end border-t border-solid border-slate-200 rounded-b"
                >
                  <AutoClose setShowModal={setShowModal} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-[102] bg-black"></div>
    </div>
  );
};

export default Modal;
